// const lastValueFrom = require('rxjs');
// import axios from 'axios';
export class Funciones {

    constructor() { }
    /**
     * Rellena la cadena original con la cadena de relleno, tomando en cuenta la longitud deseada,
     * tomando en cuenta si se quiere completar a la izquierda o derecha.
     * Es importante tomar en cuenta que el parametro 'completar_final' esta definido por default
     * como 'false', por lo tanto se completará a la izquierda, en caso de que se requiera completar
     * a la derecha es necesario pasar un 'true' en el parametro de 'completar_final'
     *
     * @author Aldair Cruz
     *
     * @param cadenaOriginal Contiene la información que se desea rellenar
     * @param cadenaRelleno Contiene el caracter con el que se desea rellenar
     * @param longitud Es la longitud con la que se desea rellenar
     * @param completar_final Parametro que define si se completará a la derecha
     * o izquierda, el valor por default es 'false', el cual define que se completará a
     * la izquierda, en caso contrario, lo hará a la derecha.
     *
     * @return Retorna la cadena completada con la longitud deseada.
     */
    static async LPAD(cadenaOriginal: string, cadenaRelleno: string, longitud: number, completar_final: boolean = false): Promise<string> {
        return completar_final ? cadenaOriginal.padEnd(longitud, cadenaRelleno) : cadenaOriginal.padStart(longitud, cadenaRelleno);
    }

    /**
     * Función que redondea un calculo
     * 
     * <b>Autor: </b> Aldair Cruz
     * <b>Fecha de Creación: </b> 12/03/2022
     * 
     * @param {double} importe importe que será redondeado
     * @param {int} decimales Limite de Decimales a las cuales se redondeara
     * @returns regresa el impoorte redondeado
     */
    static round(importe:number, decimales: number) {
        importe = Number(importe);
        return Number(importe.toFixed(decimales));
    }

    static totalCampo(array: any[], key: string, redondeo_decimales: number) {
        return Funciones.round(array.map(item => item[key]).reduce((valor_anterior, valor_actual) => valor_anterior + valor_actual, 0), redondeo_decimales);
    }

    /**
     * Convierte el Numero Recibido en un formato de moneda
     * 
     * @param {double} importe 
     */
    static getMoneda(importe: number) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 })
            .format(importe)
            .replace('MX', '');
    }

    /**
     * Convierte el Numero Recibido en un formato de porcentaje
     * 
     * @param {double} importe 
     * @return retornara el importe en formato porcentaje <br>
     * ej. si importe es 1000 retornara $ 1,000.00 ej. si importe es 3.14151618
     * retornara 3.14%
     */
    static getPorcentaje(importe: number) {
        return new Intl.NumberFormat('en-US', {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(importe);
    }


    /**
     * Devuelve una copia profunda de cualquier tipo de objeto o dato.
     * @param {any} objeto 
     * @returns 
     */
    static copiaProfunda(objeto : any ) : unknown{

        const json_objeto = JSON.stringify(objeto)
        const copy = JSON.parse(json_objeto)
        return copy;

    }

    static async cargarCampo(objeto: any, campo: any, valor: any) {
        if(valor != null && valor.trim() != undefined && valor.trim() != '') {
            objeto[campo] = valor;
        }
    }

    // static  realizarLlamadoApi(
    //     bearer_token: string, url: string, 
    //     body: any, auth: any, method: string
    //   ) {
        
    //     const config: any = {};
        
    //     config['method'] = method;
    //     config['url'] = url;
    
    //     if (bearer_token.trim() != '') {
    //       const headerRequest: any = {};
    //       headerRequest['Content-Type'] = 'application/json';
    //       headerRequest['Authorization'] = `Bearer ${bearer_token}`;
    //       config['headers'] = headerRequest;
    //     }
    
    //     if(auth != undefined && auth != '') {
    //       config['auth'] = auth;
    //     }
    
    //     if(body != undefined && body != '') {
    //       config['data'] = body;
    //     }
    
    //    return axios.request(config).then((res:any) => {
    //         return res.data;
    //     }).catch((error:any) => {
    //         return error;
    //     }) ;
    //   }

}